import { jsx as _jsx } from "react/jsx-runtime";
import { useAnalytics, useAnalyticsAttributes, useLanguage } from '..';
import { LANGUAGES, isLanguageCode } from '../../languages';
import { LanguageForm } from './LanguageSelectForm.styles';
export function LanguageSelectForm({ iconColor = 'N0', selectLanguageLabel, showGlobeIcon = true }) {
    const currentLanguage = useLanguage();
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (_jsx(LanguageForm, Object.assign({ showGlobeIcon: showGlobeIcon, iconColor: iconColor }, { children: _jsx("select", Object.assign({ "aria-label": selectLanguageLabel, value: currentLanguage, onChange: ({ target }) => {
                const { value: selectedLanguage } = target;
                const segments = location.pathname.split('/').slice(1);
                sendTrackEvent('selectedLanguage', Object.assign(Object.assign({}, analyticsAttributes), { event: 'selected', eventComponent: 'language', label: `${selectedLanguage} language`, labelEnglish: `${selectedLanguage} language`, uuid: `${selectedLanguage}_language` }));
                if (isLanguageCode(segments[0])) {
                    location.assign(`/${selectedLanguage}/${segments.slice(1).join('/')}`);
                }
                else {
                    location.assign(`/${selectedLanguage}/${segments.join('/')}`);
                }
            }, "data-testid": "language-select" }, { children: LANGUAGES.map(({ code, name }) => (_jsx("option", Object.assign({ value: code, "data-uuid": `${code}_language` }, { children: name }), code))) }), void 0) }), void 0));
}
//# sourceMappingURL=LanguageSelectForm.js.map